export default "__VITE_ASSET__512b5cb3__"